import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Hilo from "./games/hilo/Hilo";
import { ChakraProvider } from "@chakra-ui/react";
import Plotle from "./games/plotle/Plotle";
import MathSquares from "./games/math-squares/MathSquares";
import Expansion from "./games/expansion/Expansion";
import Encrypedia from "./games/encrypedia/Encrypedia";
import ByTheNumbers from "./games/by-the-numbers/ByTheNumbers";
import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
} as const;

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/hilo",
    element: <Hilo />,
  },
  {
    path: "/plotle",
    element: <Plotle />,
  },
  {
    path: "/squares",
    element: <MathSquares />,
  },
  {
    path: "/expansion",
    element: <Expansion />,
  },
  {
    path: "/encrypedia",
    element: <Encrypedia />
  }, 
  {
    path: "/by-the-numbers",
    element: <ByTheNumbers />
  }
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <PostHogProvider apiKey="phc_HNy0EyHQJOCwdTYYGGiyUL1QVUVPQFOQhU4QJTwsqVI" options={options}>
      <ChakraProvider>
        <RouterProvider router={router} />
      </ChakraProvider>
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
